import React,{useMemo} from 'react';
import SectionTitle from '../../components/Common/SectionTitle';
import Footer from '../../components/Layout/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import ServiceDetailsContent from './ServiceDetailsContent';

// Breadcrumbs Image
import breadcrumbsImg from '../../assets/img/breadcrumbs/2.jpg';
import serviceImg from '../../assets/img/service/main-home/5.png';
import DetailsHeader from '../../components/Layout/Header/DetailsHeader';

const Partnerships = () => {
    const content = useMemo(() => {
        return <SectionTitle
            sectionClass="sec-title4"
            descClass="desc desc-big"
            description="Identify and negotiate strategic partnerships that accelerate growth and expand market access."
        />
    }, [])
    return (
        <React.Fragment>
            <DetailsHeader
                parentMenu='service'
                secondParentMenu='services'
                activeMenu='/partnerships-alliances'
            />
            <SiteBreadcrumb
                breadcrumbsImg={breadcrumbsImg}
                pageTitle='Strategic Partnerships & Alliances'
                pageCategory='Services'
                pageName='Partnerships'
                parentPath="/service"
            />
            <ServiceDetailsContent title="Strategic Partnerships & Alliances" subtitle="Partnerships" children={content} serviceImg={serviceImg}/>
            <Footer footerClass="rs-footer" />
            <SearchModal />
        </React.Fragment>
    );
}

export default Partnerships;
